import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Col,
    PageHeader,
    Row,
    Spin,
    Form as FormInitial,
    message,
    Select,
    Tag,
    Checkbox,
    Tooltip,
} from "antd";
import {
    ButtonItem,
    Form,
    InputNumberItem,
    SelectItem,
    TextAreaItem,
    FormItem,
    DatePickerItem,
    SelectInsumosItem
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import axios from "axios";
import VerRequisicionPdf from "../EditarRequisicion/VerRequisicionPdf/VerRequisicionPdf";
import moment from "moment";
import AsignarProveedor from "../AsignarProveedor/AsignarProveedor";
import ModalVerRequisicion from "../ModalVerRequisicion/ModalVerRequisicion";
import ModalMandarWorkBench from "../ModalMandarWorkBench/ModalMandarWorkBench";
import { ArrowUpOutlined, CarOutlined, CaretDownOutlined, CaretUpOutlined, CheckCircleOutlined, EnvironmentOutlined, FireOutlined, InfoCircleOutlined, WarningOutlined, UserOutlined } from "@ant-design/icons";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";

const { Option } = Select;

class MandarWorkBench extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasProveedores: null,
        objetoProveedoresPInsumos: [],
        objetoProyectos: null,
        todasProyectos: null,
        objetoInsumos: null,
        todasInsumos: [],
        impuestos: [],
        numeroRequisicion: 0,
        presupuestoPU: false,
        presupuestoPUId: null,
        modalElegirTipoDeProveedor: false,
        modalElegirTipoDeProveedorId: null,
        modalElegirTipoDeProveedorNombre: null,
        modalVerPdf: false,
        modalVerPdfId: null,
        modalAsignarProveedor: false,
        modalAsignarProveedorInsumoId: null,
        todosUsuarios: [],
        objetoUsuarios: null,
        proyectoId: null,
        requisicionesAdicionales: [],
        modalMandarAWorkbench: false,
        workbench: this.props?.location?.state?.workbench || false,
        seleccionados: new Set(),
        colapsadoYaPedidos: true,
    };
    componentDidMount() {
        this.consultarTodo();
    }

    abrirModalVerPdf() {
        this.setState({ modalVerPdf: true, modalVerPdfId: this.props.location.state.id })
    }

    cerrarModalVerPdf() {
        this.setState({ modalVerPdf: false, modalVerPdfId: null })
    }

    promisedSetState = (newState) =>
        new Promise((resolve) => this.setState(newState, resolve));

    async consultarTodo() {
        this.setState({ loading: true });
        const responseProveedores = axios.post(
            "proveedores/selectProveedoresConTipoDeProveedor",
            { empresaId: this.props.empresaId },
            {
                headers: this.props.headersToken,
            }
        );

        const responseProyectos = axios.post(
            "proyectos/selectProyectos",
            { empresaId: this.props.empresaId },
            {
                headers: this.props.headersToken,
            }
        );

        axios.post(
            "usuarios/selectUsuariosEmpresa",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
        ).then(res => {
            if (res.data.status === 404) return [];

            this.setState({
                todosUsuarios: res.data,
                objetoUsuarios:
                    res.data.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.nombre} {value.apellidoPaterno} {value.apellidoMaterno}
                            </Option>
                        )
                    })
            });
        }
        );


        const responses = await Promise.all([
            responseProveedores,
            responseProyectos,
        ]);

        let newState = {};

        if (responses[0].data.status === 404) {
        } else {
            newState.todasProveedores = responses[0].data;
            newState.objetoProveedores = responses[0].data.map((value) => {
                return (
                    <Option value={value._id} key={value._id}>
                        {value.stringBuscar}
                    </Option>
                );
            });
        }

        if (responses[1].data.status === 404) {
        } else {
            newState.todasProyectos = responses[1].data;
            newState.objetoProyectos = responses[1].data.map((value) => {
                return (
                    <Option value={value._id} key={value._id}>
                        {value.nombre}
                    </Option>
                );
            });
        }

        await this.promisedSetState(newState);

        let secondState = { loading: false }

        await axios
            .post(
                this.state.workbench ? "workbenchRequisiciones/datosWorkBench" : "requisiciones/datosRequisicion",
                {
                    empresaId: this.props.empresaId,
                    requisicionId: this.props.location.state.id,
                },
                { headers: this.props.headersToken }
            )
            .then(async (res) => {
                if (res.data.success === 2) {
                    this.setState({ proyectoId: res.data.requisicion.proyectoId, requisicionesAdicionales: res.data.requisicionesAdicionales })
                    this.formRef.current.setFieldsValue({
                        ...res.data.requisicion,
                        solicitanteId: res.data.requisicion.solicitanteId || res.data.requisicion.usuarioId,

                        fechaEntrega: res.data.requisicion.fechaEntrega ? moment(res.data.requisicion.fechaEntrega) : null,
                        fechaSolicitud: res.data.requisicion.fechaSolicitud ? moment(res.data.requisicion.fechaSolicitud) : null,
                    });

                    if (res.data.requisicion.insumos && res.data.requisicion?.insumos?.length > 0) {

                        const inventarioPromises = res.data.requisicion.insumos.map(async (valueInsumo, index) => {
                            const insumo = res.data.insumos.find(
                                (valueInsumos) => valueInsumos._id === valueInsumo.insumoId
                            );

                            if (insumo && (insumo.inventariable || insumo.insumoCompuesto)) {
                                try {
                                    const inventarioRes = await axios.post(
                                        "inventarios/inventarioInsumoProyecto",
                                        {
                                            proyectoId: this.state.proyectoId,
                                            insumoId: valueInsumo.insumoId,
                                            noPrincipal: insumo.noPrincipal,
                                            insumoCompuesto: insumo.insumoCompuesto,
                                            empresaId: this.props.empresaId,
                                            pedidosSeleccionados: this.state.pedidosSeleccionados
                                        },
                                        { headers: this.props.headersToken }
                                    );
                                    return { index, inventario: inventarioRes.data.cantidad };
                                } catch (error) {
                                    console.error("Error al obtener inventario:", error);
                                    return { index, inventario: null };
                                }
                            } else if (insumo) {
                                return { index, inventario: "No inventariable" };
                            }
                            return { index, inventario: null };
                        });

                        const inventarios = await Promise.all(inventarioPromises);

                        let insumosConInventario = [...res.data.requisicion.insumos];
                        inventarios.forEach(({ index, inventario }) => {
                            if (inventario !== null) {
                                insumosConInventario[index].inventario = inventario;
                            }
                        });

                        insumosConInventario = insumosConInventario.map(valueInsumo => {
                            const insumoBuscar = res.data.insumos.find(v => v._id.toString() === valueInsumo.insumoId.toString());
                            return {
                                ...valueInsumo,
                                familiaNombre: insumoBuscar?.familia?.nombre || '',
                                familiaId: insumoBuscar?.familiaId || '',
                            };
                        });

                        this.formRef.current.setFieldsValue({
                            insumos: insumosConInventario
                        });


                        let objetoProveedoresPInsumos = res.data.requisicion.insumos.map(valueInsumo => {

                            const insumo = res.data.insumos.find(
                                (valueInsumos) => valueInsumos._id === valueInsumo.insumoId
                            );

                            if (!insumo) return (
                                <Option value={0} key={0} disabled>
                                    Seleccione un insumo para ver sus proveedores
                                </Option>
                            );

                            let objetoProveedores = []

                            if (insumo.relaciones && insumo.relaciones?.length > 0) {

                                let keysProveedores = []

                                for (const relacion of insumo.relaciones) {
                                    if (relacion.estado !== 0) {

                                        const indexProv = keysProveedores.findIndex(valueKey => valueKey.toString() === relacion.proveedorId.toString())

                                        if (indexProv === -1) {
                                            keysProveedores.push(relacion.proveedorId.toString())
                                        }

                                    }
                                }

                                for (const proveedorId of keysProveedores) {

                                    const proveedor = this.state.todasProveedores.find(
                                        (valueProveedores) =>
                                            valueProveedores._id.toString() === proveedorId.toString()
                                    );

                                    if (!proveedor) continue;

                                    objetoProveedores.push(
                                        <Option value={proveedor._id} key={proveedor._id}>
                                            {proveedor.stringBuscar}
                                        </Option>
                                    )

                                }
                            }


                            return objetoProveedores;

                        })

                        secondState.objetoProveedoresPInsumos = objetoProveedoresPInsumos

                    }
                    secondState.numeroRequisicion = res.data.requisicion.numero
                    secondState.presupuestoPU = res.data.requisicion.presupuestoPU
                    secondState.presupuestoPUId = res.data.requisicion.presupuestoPUId
                    secondState.todasInsumos = res.data.insumos;
                } else {
                    message.error("Error no se encontro informacion de la requisición");
                }
            });

        await this.promisedSetState(secondState);
    }
    atras() {
        this.props.history.goBack();
    }

    async onChangeInsumo(value, key, insumoEncontrado) {
        this.setState({ loading: true });
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        const insumoId = arrayValue[key].insumoId;
        let insumo
        if (insumoEncontrado) {
            insumo = insumoEncontrado;
            const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
            if (!yaExiste) {
                await this.setState(prev => ({
                    todasInsumos: [...prev.todasInsumos, insumo]
                }));
            }
        } else {
            insumo = this.state.todasInsumos.find(
                (valueInsumos) => valueInsumos._id === insumoId
            );
        }
        this.setState({ loading: false });
        if (!insumo) {
            this.setState({ loading: false });
            return
        }
        if (insumo.inventariable || insumo.insumoCompuesto) {
            await axios
                .post(
                    "inventarios/inventarioInsumoProyecto",
                    {
                        proyectoId: this.state.proyectoId,
                        insumoId: insumoId,
                        noPrincipal: insumo.noPrincipal,
                        insumoCompuesto: insumo.insumoCompuesto,
                        empresaId: this.props.empresaId,
                        pedidosSeleccionados: this.state.pedidosSeleccionados
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    arrayValue[key].inventario = res.data.cantidad;
                });
        } else {
            arrayValue[key].inventario = "No inventariable";
        }
        this.setState({ loading: false });

        let objetoProveedores = []

        if (insumo.relaciones && insumo.relaciones?.length > 0) {

            let keysProveedores = []

            for (const relacion of insumo.relaciones) {
                if (relacion.estado !== 0) {

                    const indexProv = keysProveedores.findIndex(valueKey => valueKey.toString() === relacion.proveedorId.toString())

                    if (indexProv === -1) {
                        keysProveedores.push(relacion.proveedorId.toString())
                    }

                }
            }

            for (const proveedorId of keysProveedores) {

                const proveedor = this.state.todasProveedores.find(
                    (valueProveedores) =>
                        valueProveedores._id.toString() === proveedorId.toString()
                );

                if (!proveedor) continue;

                objetoProveedores.push(
                    <Option value={proveedor._id} key={proveedor._id}>
                        {proveedor.stringBuscar}
                    </Option>
                )

            }
        }


        let objetoProveedoresPInsumos = [...this.state.objetoProveedoresPInsumos]

        objetoProveedoresPInsumos[key] = objetoProveedores


        this.setState({ objetoProveedoresPInsumos })

        if (!insumo?.proveedorDefaultId) return;

        const proveedor = this.state.todasProveedores.find(
            (valueProveedores) =>
                valueProveedores._id.toString() === insumo.proveedorDefaultId.toString()
        );

        const encontrarRelacion = insumo.relaciones.some(value => value.proveedorId.toString() === insumo.proveedorDefaultId.toString())

        if (encontrarRelacion) {

            arrayValue[key].proveedorId = proveedor ? proveedor._id : undefined;

        }

        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }

    asignarProveedor(key) {
        const insumos = this.formRef.current.getFieldValue("insumos");
        const arrayValue = insumos[key];
        if (!arrayValue) return;
        if (!arrayValue.insumoId) {
            message.error("Selecciona un insumo primero");
            return;
        }
        this.setState({
            modalAsignarProveedor: true,
            modalAsignarProveedorInsumoId: arrayValue.insumoId,
            modalAsignarProveedorKey: key
        })
    }

    async cerrarAsignarProveedor(nuevoInsumo) {
        if (nuevoInsumo) {
            const todasInsumos = [...this.state.todasInsumos];
            const buscarInsumoIndex = todasInsumos.findIndex(i => i._id === nuevoInsumo._id);
            if (buscarInsumoIndex !== -1) {
                todasInsumos[buscarInsumoIndex] = nuevoInsumo;
            }
            await this.setState({ todasInsumos });
            this.onChangeInsumo(undefined, this.state.modalAsignarProveedorKey);
        }
        this.setState({
            modalAsignarProveedor: false,
            modalAsignarProveedorInsumoId: null,
            modalAsignarProveedorKey: null
        });
    }

    verRequisicionModal(id) {
        this.setState({ modalVerRequisicion: true, modalVerRequisicionId: id })
    }

    cerrarModalVerRequisicion() {
        this.setState({ modalVerRequisicion: false, modalVerRequisicionId: null })
    }

    toggleSeleccion = (idx, checked) => {
        this.setState(prev => {
            const seleccionados = new Set(prev.seleccionados);
            if (checked) seleccionados.add(idx); else seleccionados.delete(idx);
            return { seleccionados };
        });
    };

    // Agrega esta función
    toggleSeleccionTodos = (checked) => {
        this.setState(prev => {
            const seleccionados = new Set();
            if (checked) {
                // Si se seleccionan todos, recorre los insumos válidos
                const insumos = this.formRef.current.getFieldValue("insumos") || [];
                insumos.forEach((ins, idx) => {
                    const deshabilitado =
                        !ins?.insumoId ||
                        (ins?.cantidad <= ins?.cantidadOrdenada) ||
                        this.state.presupuestoPU;
                    if (!deshabilitado) seleccionados.add(idx);
                });
            }
            return { seleccionados };
        });
    };

    toggleSeleccionFamilia = (familiaId, checked) => {
        this.setState(prev => {
            const seleccionados = new Set(prev.seleccionados);
            const insumos = this.formRef.current.getFieldValue("insumos") || [];
            insumos.forEach((ins, idx) => {
                if (ins?.familiaId !== familiaId) return;
                const deshabilitado = !ins?.insumoId || (ins?.cantidad <= ins?.cantidadOrdenada) || this.state.presupuestoPU;
                if (deshabilitado) return;
                if (checked) seleccionados.add(idx); else seleccionados.delete(idx);
            });
            return { seleccionados };
        });
    };

    limpiarSeleccion = () => this.setState({ seleccionados: new Set() });

    agregarAWorkbench() {
        if (this.state.seleccionados.size === 0) {
            return message.info('Selecciona al menos un insumo.');
        }

        this.setState({
            modalMandarAWorkbench: true,
        });
    }

    onCancelModalMandarAWorkbench() {
        this.setState({
            modalMandarAWorkbench: false,
        });
    }

    onConfirmModalMandarAWorkbench(workbenchId) {

        this.setState({ loading: true, modalMandarAWorkbench: false });
        axios
            .post(
                "requisiciones/mandarAWorkbench",
                {
                    seleccionados: Array.from(this.state.seleccionados),
                    workbenchId,
                    requisicionId: this.props.location.state.id,
                    empresaId: this.props.empresaId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se han agregado los insumos al Workbench");
                    this.formRef.current.resetFields();
                    this.atras();
                } else {
                    message.error(res.data.message || "Hubo un error y no se agregaron los insumos al Workbench");
                }
            });
    }

    obtenerColorTagRequisicion = (importancia) => {
        switch (importancia) {
            case 3:
                return "red";
            case 2:
                return "orange";
            case 1:
                return "green";
            default:
                return "blue";
        }
    };

    render() {
        const isMobile = window.innerWidth <= 1000;
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title={(this.state.workbench ? "Traspaso entre workbenchs " : "Mandar Workbench ") + "#" + this.state.numeroRequisicion}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background">
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="mandarRequisicionWorkBench"
                            layout
                        >
                            <GeneralFormLayout
                                isMobile={isMobile}
                                cards={[
                                    {
                                        title: "Datos Generales",
                                        lg: 12,
                                        xl: 12,
                                        content: (
                                            <>
                                                <FormItem
                                                    label="Fecha Solicitud"
                                                    name="fechaSolicitud"
                                                    margin
                                                >
                                                    <DatePickerItem
                                                        disabled
                                                        placeholder="Fecha de Solicitud"
                                                    />
                                                </FormItem>
                                                <FormItem
                                                    label="Fecha Entrega"
                                                    name="fechaEntrega"
                                                    margin
                                                >
                                                    <DatePickerItem
                                                        disabled
                                                        placeholder="Fecha de Entrega"
                                                    />
                                                </FormItem>
                                                <FormItem
                                                    label="Solicitante"
                                                    name="solicitanteId"
                                                    tooltip="Usuario que solicita la requisición, si no se selecciona, se asigna al usuario que crea la requisición por defecto."

                                                    margin
                                                >
                                                    <SelectItem disabled placeholder="Seleeccione a quién se le asignará la requisición">
                                                        {this.state.objetoUsuarios}
                                                    </SelectItem>
                                                </FormItem>
                                                <FormItem
                                                    label="Proyecto"
                                                    name="proyectoId"
                                                    margin
                                                    required
                                                >
                                                    <SelectItem disabled placeholder="Proyecto">
                                                        {this.state.objetoProyectos}
                                                    </SelectItem>
                                                </FormItem>
                                            </>
                                        ),
                                    },
                                    {
                                        title: "Extras",
                                        lg: 12,
                                        xl: 12,
                                        content: (
                                            <>
                                        <FormItem
                                            label="Importancia"
                                            name="importancia"
                                            tooltip="Nivel de importancia: 1 = Baja, 2 = Media, 3 = Alta"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                        >
                                            <SelectItem placeholder="Seleccione nivel de importancia" disabled style={{ width: "100%" }}>
                                                <Option value={1}>
                                                    <Tag color="green" style={{ marginRight: 8 }}>
                                                        <ArrowUpOutlined /> Baja
                                                    </Tag>
                                                </Option>
                                                <Option value={2}>
                                                    <Tag color="orange" style={{ marginRight: 8 }}>
                                                        <WarningOutlined /> Media
                                                    </Tag>
                                                </Option>
                                                <Option value={3}>
                                                    <Tag color="red" style={{ marginRight: 8 }}>
                                                        <FireOutlined /> Alta
                                                    </Tag>
                                                </Option>
                                            </SelectItem>
                                        </FormItem>
                                        {this.state.workbench && (
                                            <FormItem
                                                label="Prov."
                                                name="proveedorId"
                                                margin
                                                labelCol={{ span: 7 }}
                                                wrapperCol={{ span: 17 }}
                                            >
                                                <SelectProveedoresItem
                                                    empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                    headersToken={this.props.headersToken}
                                                    sinBorde
                                                    autoFocus
                                                    disabled
                                                    dropdownMatchSelectWidth={600}
                                                    width="100%"
                                                    placeholder="Proveedor"
                                                />
                                            </FormItem>
                                        )}
                                        <FormItem
                                            label="Observaciones"
                                            name="observaciones"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                            pattern
                                        >
                                            <TextAreaItem disabled placeholder="Observaciones" />
                                        </FormItem>
                                            </>
                                        ),
                                    },
                                ]}
                            />
                            <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                    let proyectoId = getFieldValue("proyectoId");
                                    if (!proyectoId)
                                        return null;
                                    let proyecto = this.state.todasProyectos.find(
                                        (value) => value._id === proyectoId
                                    );
                                    return (
                                        <div style={{ padding: "0 16px", marginBottom: 16 }}>
                                            <Row>
                                                <InfoCard
                                                    title="PROYECTO"
                                                    icon={<InfoCircleOutlined />}
                                                    accentColor="#00BFD6"
                                                    compact
                                                    sections={[
                                                        {
                                                            title: "Información General",
                                                            icon: <InfoCircleOutlined />,
                                                            iconColor: "#00BFD6",
                                                            lg: 8,
                                                            items: [
                                                                { label: "Nombre", value: proyecto.nombre || "-" },
                                                                { label: "Descripción", value: proyecto.descripcion || "-" },
                                                            ],
                                                        },
                                                        {
                                                            title: proyecto.calle ? "Dirección" : "Vehículo",
                                                            icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                                                            iconColor: "#C9DF00",
                                                            lg: 8,
                                                            items: proyecto.calle
                                                                ? [
                                                                    { label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` },
                                                                ]
                                                                : [
                                                                    { label: "Marca", value: proyecto.marca || "-" },
                                                                    { label: "Modelo", value: proyecto.modelo || "-" },
                                                                    { label: "Placas", value: proyecto.placas || "-" },
                                                                ],
                                                        },
                                                        {
                                                            title: "Detalles",
                                                            icon: <CarOutlined />,
                                                            iconColor: "#FF6A0D",
                                                            lg: 8,
                                                            items: [
                                                                { label: "Tipo", value: proyecto.calle ? "Dirección física" : "Vehículo" },
                                                                { label: "ID", value: proyecto._id?.slice(-6).toUpperCase() || "—" },
                                                            ],
                                                        },
                                                    ]}
                                                />
                                            </Row>
                                        </div>
                                    );
                                }}
                            </FormItem>
                            <GeneralFormLayout
                                isMobile={isMobile}
                                tabsConfig={{
                                    tabs: [
                                        {
                                            key: "insumos",
                                            label: "Insumos",
                                            forceRender: true,
                                            customContent: (
                                                <div className="tabla-insumos-venta" style={{ overflowX: "auto" }}>
                                <FormInitial.List name="insumos">
                                    {(fields, { add, remove }) => (
                                        <>
                                            <table className="table table-12px" style={{ backgroundColor: "white" }}>
                                                {fields.length > 0 ? (
                                                    <thead>
                                                        <tr>
                                                            <th className="th-border" style={{ width: "4%", textAlign: "center" }}>
                                                                <Checkbox
                                                                    indeterminate={
                                                                        this.state.seleccionados.size > 0 &&
                                                                        this.state.seleccionados.size < (this.formRef.current.getFieldValue("insumos") || []).length
                                                                    }
                                                                    checked={
                                                                        this.state.seleccionados.size > 0 &&
                                                                        this.state.seleccionados.size === (this.formRef.current.getFieldValue("insumos") || []).filter(ins =>
                                                                            ins?.insumoId && ins?.cantidad > ins?.cantidadOrdenada && !this.state.presupuestoPU
                                                                        ).length
                                                                    }
                                                                    onChange={(e) => this.toggleSeleccionTodos(e.target.checked)}
                                                                />
                                                            </th>
                                                            <th
                                                                className="th-border"
                                                                style={{ width: "3%" }}
                                                            >
                                                                #
                                                            </th>
                                                            <th
                                                                className="th-border"
                                                                style={{ width: "27%" }}
                                                            >
                                                                Insumo
                                                            </th>
                                                            <th
                                                                className="th-border"
                                                                style={{ width: "6%" }}
                                                            >
                                                                Unidad
                                                            </th>
                                                            <th
                                                                className="th-border"
                                                                style={{ width: "10%" }}
                                                            >
                                                                Inventario
                                                            </th>
                                                            <th
                                                                className="th-border"
                                                                style={{ width: "8%" }}
                                                            >
                                                                Cantidad
                                                            </th>
                                                            <th
                                                                className="th-border"
                                                                style={{ width: "7%" }}
                                                            >
                                                                Ord.
                                                            </th>
                                                            <th
                                                                className="th-border"
                                                                style={{ width: "9%" }}
                                                            >
                                                                Req.
                                                            </th>
                                                            <th
                                                                className="th-border"
                                                                style={{ width: "20%" }}
                                                            >
                                                                Proveedor
                                                            </th>
                                                            <th
                                                                className="th-border"
                                                                style={{ width: "6%" }}
                                                            >
                                                                Accion
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                ) : null}
                                                {(() => {
                                                    const insumosList = this.formRef.current?.getFieldValue("insumos") || [];
                                                    const pendientes = [];
                                                    const yaPedidos = [];
                                                    fields.forEach((field) => {
                                                        const arrayKey = field.name;
                                                        const ins = insumosList[arrayKey];
                                                        const deshabilitado = !ins?.insumoId || (ins?.cantidad <= ins?.cantidadOrdenada) || this.state.presupuestoPU;
                                                        if (deshabilitado) yaPedidos.push({ field, arrayKey });
                                                        else pendientes.push({ field, arrayKey });
                                                    });
                                                    const sortByFamilia = (a, b) => {
                                                        const insA = insumosList[a.arrayKey];
                                                        const insB = insumosList[b.arrayKey];
                                                        if (insA?.familiaNombre && insB?.familiaNombre) return insA.familiaNombre.localeCompare(insB.familiaNombre);
                                                        if (insA?.familiaNombre) return -1;
                                                        if (insB?.familiaNombre) return 1;
                                                        return 0;
                                                    };
                                                    pendientes.sort(sortByFamilia);
                                                    yaPedidos.sort(sortByFamilia);

                                                    const familiaRefPendientes = { id: null };
                                                    const familiaRefYaPedidos = { id: null };

                                                    const renderFila = ({ field, arrayKey }, familiaRef, numeroFila) => {
                                                        const { key, name, fieldKey, ...restField } = field;
                                                        return (
                                                            <tbody key={arrayKey}>
                                                                <FormItem noStyle shouldUpdate>
                                                                    {({ getFieldValue }) => {
                                                                        const insumos = getFieldValue("insumos");
                                                                        const insumo = insumos[arrayKey];
                                                                        const mostrarFamilia = insumo?.familiaId !== familiaRef.id;
                                                                        if (mostrarFamilia) familiaRef.id = insumo?.familiaId;
                                                                        const origenesRequisicion = Array.isArray(insumo?.requisicionesOrigen) && insumo.requisicionesOrigen.length > 0
                                                                            ? insumo.requisicionesOrigen
                                                                            : (insumo?.requisicionId ? [{ requisicionId: insumo.requisicionId, cantidad: insumo?.cantidad }] : []);
                                                                        const tagsRequisicion = origenesRequisicion
                                                                            .map(origen => this.state.requisicionesAdicionales.find(r => r._id === origen.requisicionId))
                                                                            .filter(Boolean)
                                                                            .map(req => ({ id: req._id, nombre: req.numero, fechaSolicitud: req.fechaSolicitud, importancia: req.importancia }));
                                                                        return (
                                                                            <>
                                                                                {mostrarFamilia && (
                                                                                    <tr style={{ backgroundColor: "#e6f7ff" }}>
                                                                                        <td className="td-border" style={{ textAlign: 'center', borderBottom: '1px solid #91d5ff' }}>
                                                                                            {(() => {
                                                                                                const il = getFieldValue("insumos") || [];
                                                                                                const habilitados = il.filter(ins => ins?.familiaId === insumo?.familiaId && ins?.insumoId && ins?.cantidad > ins?.cantidadOrdenada && !this.state.presupuestoPU);
                                                                                                const seleccionadosFamilia = il.reduce((acc, ins, i) => ins?.familiaId === insumo?.familiaId && this.state.seleccionados.has(i) ? acc + 1 : acc, 0);
                                                                                                return (
                                                                                                    <Checkbox
                                                                                                        indeterminate={seleccionadosFamilia > 0 && seleccionadosFamilia < habilitados.length}
                                                                                                        checked={habilitados.length > 0 && seleccionadosFamilia === habilitados.length}
                                                                                                        onChange={(e) => this.toggleSeleccionFamilia(insumo?.familiaId, e.target.checked)}
                                                                                                    />
                                                                                                );
                                                                                            })()}
                                                                                        </td>
                                                                                        <td className="td-border" colSpan="9" style={{ textAlign: 'left', padding: '8px 16px', borderBottom: '1px solid #91d5ff' }}>
                                                                                            <span style={{ fontWeight: '800', fontSize: 11, color: '#0050b3', textTransform: 'uppercase', letterSpacing: 1 }}>
                                                                                                {insumo?.familiaNombre || 'Sin Familia'}
                                                                                            </span>
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                                <tr>
                                                                                    <td className="td-border" style={{ textAlign: "center" }}>
                                                                                        <FormItem noStyle shouldUpdate>
                                                                                            {({ getFieldValue }) => {
                                                                                                const ins = getFieldValue("insumos")?.[arrayKey];
                                                                                                const deshabilitado = !ins?.insumoId || (ins?.cantidad <= ins?.cantidadOrdenada) || this.state.presupuestoPU;
                                                                                                const checked = this.state.seleccionados.has(arrayKey);
                                                                                                return (
                                                                                                    <Checkbox
                                                                                                        checked={checked}
                                                                                                        disabled={deshabilitado}
                                                                                                        onChange={(e) => this.toggleSeleccion(arrayKey, e.target.checked)}
                                                                                                    />
                                                                                                );
                                                                                            }}
                                                                                        </FormItem>
                                                                                    </td>
                                                                                    <td className="td-border">
                                                                                        <div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>
                                                                                            {numeroFila + 1}
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="td-border">
                                                                                        <FormItem {...restField} name={[name, "insumoId"]} required noStyle>
                                                                                            <SelectInsumosItem
                                                                                                disabled
                                                                                                empresaId={this.props.empresaId}
                                                                                                headersToken={this.props.headersToken}
                                                                                                sinBorde
                                                                                                autoFocus
                                                                                                dropdownMatchSelectWidth={600}
                                                                                                width="100%"
                                                                                                placeholder="Insumo"
                                                                                                tiposInsumos="compra"
                                                                                                ocultarCodigoYUnidad
                                                                                                onChange={(value, insumo) => this.onChangeInsumo(value, arrayKey, insumo)}
                                                                                            />
                                                                                        </FormItem>
                                                                                    </td>
                                                                                    <td className="td-border">
                                                                                        {(() => {
                                                                                            const insumoMaestro = this.state.todasInsumos?.find(
                                                                                                (v) => v._id?.toString() === insumo?.insumoId?.toString()
                                                                                            );
                                                                                            const unidad = insumoMaestro?.unidad;
                                                                                            const unidadTexto = typeof unidad === "object" && unidad !== null
                                                                                                ? (unidad.nombre || unidad.descripcion || "-")
                                                                                                : (unidad || "-");
                                                                                            return (
                                                                                                <div style={{ fontSize: "14px", textAlign: "center", color: "#868585" }}>
                                                                                                    {unidadTexto}
                                                                                                </div>
                                                                                            );
                                                                                        })()}
                                                                                    </td>
                                                                                    <td className="td-border">
                                                                                        <FormItem {...restField} name={[name, "inventario"]} noStyle>
                                                                                            <InputNumberItem sinBorde disabled placeholder="Inventario" />
                                                                                        </FormItem>
                                                                                    </td>
                                                                                    <td className="td-border">
                                                                                        <FormItem {...restField} name={[name, "cantidad"]} required number noStyle>
                                                                                            <InputNumberItem disabled sinBorde placeholder="Cantidad" />
                                                                                        </FormItem>
                                                                                    </td>
                                                                                    <td className="td-border">
                                                                                        <FormItem {...restField} name={[name, "cantidadOrdenada"]} noStyle>
                                                                                            <InputNumberItem sinBorde placeholder="Cantidad Ordenada" disabled />
                                                                                        </FormItem>
                                                                                    </td>
                                                                                    <td className="td-border" style={{ textAlign: 'center' }}>
                                                                                        {tagsRequisicion.length > 0 ? (
                                                                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                                                                                                {tagsRequisicion.map(t => (
                                                                                                    <Tooltip key={t.id} title={"Fecha de solicitud: " + (t.fechaSolicitud ? moment(t.fechaSolicitud).format("DD/MM/YYYY") : "")}>
                                                                                                        <Tag color={this.obtenerColorTagRequisicion(t.importancia)} onClick={() => this.verRequisicionModal(t.id)}>
                                                                                                            {"Req. " + t.nombre}
                                                                                                        </Tag>
                                                                                                    </Tooltip>
                                                                                                ))}
                                                                                            </div>
                                                                                        ) : null}
                                                                                    </td>
                                                                                    <td className="td-border">
                                                                                        <FormItem {...restField} name={[name, "proveedorId"]} margin noStyle>
                                                                                            <SelectItem sinBorde style={{ width: "100%" }} placeholder="Proveedor" disabled={insumo?.estado && insumo?.estado !== 1}>
                                                                                                {this.state.objetoProveedoresPInsumos[arrayKey]}
                                                                                            </SelectItem>
                                                                                        </FormItem>
                                                                                    </td>
                                                                                    <td className="td-border-sin-right">
                                                                                        <Row className="acciones-container">
                                                                                            <Col span={24} style={{ textAlign: "center" }}>
                                                                                                <Tooltip title="Asignar Proveedor" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                                                                                                    <ButtonItem type="link" onClick={() => this.asignarProveedor(arrayKey)} icon={<UserOutlined />}>
                                                                                                    </ButtonItem>
                                                                                                </Tooltip>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </td>
                                                                                </tr>
                                                                            </>
                                                                        );
                                                                    }}
                                                                </FormItem>
                                                            </tbody>
                                                        );
                                                    };

                                                    return (
                                                        <>
                                                            {pendientes.map((item, index) => renderFila(item, familiaRefPendientes, index))}
                                                            {yaPedidos.length > 0 && (
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan="10" style={{ padding: 0, border: 'none' }}>
                                                                            <div
                                                                                onClick={() => this.setState({ colapsadoYaPedidos: !this.state.colapsadoYaPedidos })}
                                                                                style={{ background: "#f6ffed", borderLeft: "4px solid #52c41a", padding: "10px 15px", cursor: "pointer", display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#237804", marginTop: 10, marginBottom: 5 }}
                                                                            >
                                                                                <span><CheckCircleOutlined style={{ marginRight: 8 }} /> Ya pedidos ({yaPedidos.length})</span>
                                                                                <span>{this.state.colapsadoYaPedidos ? <><CaretDownOutlined /> Mostrar</> : <><CaretUpOutlined /> Ocultar</>}</span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            )}
                                                            {!this.state.colapsadoYaPedidos && yaPedidos.map((item, index) => renderFila(item, familiaRefYaPedidos, pendientes.length + index))}
                                                        </>
                                                    );
                                                })()}
                                            </table>
                                        </>
                                    )}
                                </FormInitial.List>
                                                </div>
                                            ),
                                        },
                                    ],
                                }}
                                actionButtons={
                                    <>
                                        <ButtonItem
                                            type="primary"
                                            blanco
                                            onClick={() => this.abrirModalVerPdf()}
                                        >
                                            Ver Requisicion
                                        </ButtonItem>
                                        <ButtonItem
                                            type="primary"
                                            cyanB
                                            tooltip="Agregar los insumos a un workbench existente"
                                            onClick={() => this.agregarAWorkbench()}
                                        >
                                            WorkBench
                                        </ButtonItem>
                                    </>
                                }
                            />
                        </Form>
                    </Spin>
                </div>
                <VerRequisicionPdf
                    visible={this.state.modalVerPdf}
                    requisicionId={this.state.modalVerPdfId}
                    onCancel={this.cerrarModalVerPdf.bind(this)}
                    cerrarModalVerPdf={this.cerrarModalVerPdf.bind(this)}
                />
                <AsignarProveedor
                    insumoId={this.state.modalAsignarProveedorInsumoId}
                    visible={this.state.modalAsignarProveedor}
                    cerrarAsignarProveedor={this.cerrarAsignarProveedor.bind(this)}
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                />
                <ModalVerRequisicion
                    visible={this.state.modalVerRequisicion}
                    requisicionId={this.state.modalVerRequisicionId}
                    onClose={this.cerrarModalVerRequisicion.bind(this)}
                    cerrarModalVerRequisicion={this.cerrarModalVerRequisicion.bind(this)}
                />
                <ModalMandarWorkBench
                    requisicionId={this.props?.location?.state?.id}
                    visible={this.state.modalMandarAWorkbench}
                    onCancel={this.onCancelModalMandarAWorkbench.bind(this)}
                    onConfirm={this.onConfirmModalMandarAWorkbench.bind(this)}
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    workbench={this.state.workbench}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(MandarWorkBench);
